<footer class="lp-footer">
  <div class="d-flex">
    <div class="me-auto">
      <span style="vertical-align: -webkit-baseline-middle">
        2019 - {{ currentYear }} © {{ appInfo.name }}
        |
        <a
          href="javascript:void(0)"
          class="text-muted ms-1"
          (click)="openAIDisclaimer()"
          style="text-decoration: none; cursor: pointer"
          title="AI Usage Disclaimer">
          {{ '::AiPowered' | abpLocalization }}
        </a>
      </span>
      <br />
    </div>
    <ca-user-feedback></ca-user-feedback>
  </div>
</footer>
